const KEY = "post_login_path";

export function rememberPostLoginPath(path: string) {
  try { localStorage.setItem(KEY, path); } catch {}
}

export function takePostLoginPath(): string | null {
  try {
    const path = localStorage.getItem(KEY);
    if (path) localStorage.removeItem(KEY);
    return path && path.startsWith("/") ? path : null;
  } catch {
    return null;
  }
}
